import { render, staticRenderFns } from "./producaoPCP.vue?vue&type=template&id=82ca058c"
import script from "./producaoPCP.ts?vue&type=script&lang=js&external"
export * from "./producaoPCP.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82ca058c')) {
      api.createRecord('82ca058c', component.options)
    } else {
      api.reload('82ca058c', component.options)
    }
    module.hot.accept("./producaoPCP.vue?vue&type=template&id=82ca058c", function () {
      api.rerender('82ca058c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/dashboard/producaoPCP.vue"
export default component.exports